"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDiscountPopupStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const DiscountPopupStatuses_1 = require("./DiscountPopupStatuses");
exports.useDiscountPopupStore = (0, pinia_1.defineStore)('discountPopup', {
    state: () => ({
        widgetState: DiscountPopupStatuses_1.Statuses.Suspended,
        discount: null,
        loadedDiscounts: []
    }),
    getters: {
        modalIsOpen: (state) => {
            return state.widgetState !== DiscountPopupStatuses_1.Statuses.Suspended;
        },
        modalIsLoading: (state) => {
            return state.widgetState === DiscountPopupStatuses_1.Statuses.Loading;
        },
        isNotFound: (state) => {
            return state.widgetState === DiscountPopupStatuses_1.Statuses.NotFound;
        }
    },
    actions: {
        async beginProcess(router, discountId) {
            const existingDiscount = this.loadedDiscounts.find(discount => discount.id === discountId);
            if (existingDiscount) {
                this.showDiscount(existingDiscount);
                return Promise.resolve(existingDiscount);
            }
            this.setLoading();
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_discounts', params: { id: discountId } }).href);
                const discount = response;
                this.showDiscount(discount);
                this.addLoadedDiscount(discount);
                return discount;
            }
            catch (error) {
                console.error('Failed to load discount:', error);
                this.setNotFound();
                throw error;
            }
        },
        close() {
            this.widgetState = DiscountPopupStatuses_1.Statuses.Suspended;
        },
        showDiscount(discount) {
            this.discount = discount;
            this.widgetState = DiscountPopupStatuses_1.Statuses.Showing;
        },
        setLoading() {
            this.discount = null;
            this.widgetState = DiscountPopupStatuses_1.Statuses.Loading;
        },
        setNotFound() {
            this.discount = null;
            this.widgetState = DiscountPopupStatuses_1.Statuses.NotFound;
        },
        addLoadedDiscount(discount) {
            this.loadedDiscounts.push(discount);
        }
    }
});
